"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const styled_system_1 = require("styled-system");
const styled_1 = __importDefault(require("../../../styles/styled"));
const Switch = (_a) => {
    var { label, onToggle, checked, disabled, size, monochrome } = _a, rest = __rest(_a, ["label", "onToggle", "checked", "disabled", "size", "monochrome"]);
    const handleToggle = (0, react_1.useCallback)(() => {
        if (disabled !== true) {
            onToggle(!checked);
        }
    }, [disabled, checked]);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        if (disabled !== true) {
            if (e.key === 'Tab') {
                return true;
            }
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleToggle();
            }
        }
        return false;
    }, []);
    return ((0, jsx_runtime_1.jsx)(SwitchContainer, Object.assign({ role: "checkbox", "aria-label": label, "aria-checked": checked, checked: checked, onKeyDown: handleKeyDown, onClick: handleToggle, disabled: disabled, tabIndex: disabled ? -1 : 0, size: size, monochrome: monochrome }, rest, { children: (0, jsx_runtime_1.jsx)(SwitchCircle, { checked: checked, disabled: disabled, monochrome: monochrome }) })));
};
exports.Switch = Switch;
exports.Switch.defaultProps = {
    size: 'large',
};
const SwitchContainer = styled_1.default.div(({ checked, disabled, monochrome, theme, size }) => ({
    position: 'relative',
    display: 'inline-block',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transitionProperty: 'background-color, opacity',
    transitionDuration: '0.25s',
    transitionTimingFunction: 'ease',
    border: monochrome ? `1px solid ${theme.colors.phosphorGreen}` : undefined,
    backgroundColor: checked ? (monochrome ? theme.colors.phosphorGreen : theme.colors.azure) : (monochrome ? theme.colors.black : theme.colors.grey30),
    boxShadow: 'inset 0px 2px 2px rgba(44, 44, 44, 0.24), inset 0px 0px 2px rgba(0, 0, 0, 0.12)',
    opacity: disabled ? 0.3 : 1,
    '.js-focus-visible &:focus:not(.focus-visible)': {
        outline: 'none',
        boxShadow: 'inset 0px 2px 2px rgba(44, 44, 44, 0.24), inset 0px 0px 2px rgba(0, 0, 0, 0.12)',
    },
    height: '1.2em',
    width: '2em',
    borderRadius: '0.6em',
    fontSize: size === 'large' ? '20px' : '12px',
}), styled_system_1.space);
const SwitchCircle = styled_1.default.div(({ checked, monochrome, theme }) => ({
    position: 'absolute',
    width: '1em',
    height: '1em',
    borderRadius: '50%',
    transition: 'right 0.25s ease',
    border: monochrome ? `1px solid ${theme.colors.phosphorGreen}` : undefined,
    backgroundColor: monochrome ? theme.colors.black : theme.colors.white,
    margin: '0.1em 0',
    right: checked ? '0.1em' : 'calc(100% - 1.1em)',
    boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.24)',
}));
//# sourceMappingURL=switch.js.map